import { Paper, Stepper, Box, StepperProps } from '@mui/material';

export interface SideStepperProps extends StepperProps {
  /** Child Component(s) (MUI Step expected) */
  children: React.ReactNode | React.ReactNode[];
  /** Current active step */
  activeStep: number;
}

export const SideStepper = ({ children, activeStep }: SideStepperProps) => (
  <Box
    sx={{
      maxWidth: 'fit-content'
    }}
  >
    <Paper
      data-testid="SideStepperPaper"
      elevation={4}
      sx={{
        borderRadius: '0rem 0.5rem 0.5rem 0rem',
        borderLeft: 6,
        borderColor: 'primary.main'
      }}
    >
      <Stepper
        data-testid="SideStepper"
        activeStep={activeStep}
        sx={{
          ml: 2,
          pt: 2,
          pb: 2,
          pr: 20
        }}
        orientation="vertical"
        nonLinear
      >
        {children}
      </Stepper>
    </Paper>
  </Box>
);

export default SideStepper;
